module.exports = __webpack_public_path__ + "img/icon-male-hand-palm-outline.4489dc95.svg";